import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgHighTrust(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="5 -4 14 24" {...props}>
      <path
        d="M12.508 9.734l-1.279 1.184-.006.006-1.287-1.18.005-.005-1.503-1.375 1.28-1.184 1.503 1.375 3.93-3.631L16.438 6.1zm5.52-7.422l-2.382-.16a4.032 4.032 0 01-2.444-1.05L12.002 0l-1.206 1.102a4.018 4.018 0 01-2.439 1.05l-2.385.16L5 8.89c0 1.325 1.555 2.58 2.557 3.414L12 16l4.442-3.695C17.445 11.47 19 10.216 19 8.89l-.972-6.58z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('HighTrust')(SvgHighTrust);
